import React, { useState } from 'react'
import './qualification.css'

const Qualification = () => {
    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    }

  return (
    <section className='qualification section'>
        <h2 className="section__title" data-aos="fade-right">Qualification</h2>
        <span className="section__subtitle" data-aos="fade-right" data-aos-delay="200">My Personal Journey</span>

        <div className="qualification__container container">
            <div className="qualification__tabs">
                <div className={toggleState === 1 ? "qualification__button button--flex qualification__active" : "qualification__button button--flex"} onClick={() => toggleTab(1)}>
                    <i className="uil uil-graduation-cap qualification__icon"></i>
                    Education
                </div>

                <div className={toggleState === 2 ? "qualification__button button--flex qualification__active" : "qualification__button button--flex"} onClick={() => toggleTab(2)}>
                    <i className="uil uil-briefcase-alt qualification__icon"></i>
                    Experience
                </div>
            </div>

            <div className="qualification__sections">
                <div className={toggleState === 1 ? "qualification__content qualification__content-active" : "qualification__content"}>

                    <div className="qualification__data">
                        <div data-aos="zoom-in-up">
                            <h3 className="qualification__title">SMPN 200 Jakarta</h3>
                            <span className="qualification__subtitle">Student</span>
                            <div className="qualification__calender">
                                <i className="uil uil-calendar-alt"></i>
                                2014 - 2017
                            </div>
                        </div>

                        <div>
                            <span className="qualification__rounder"></span>
                            <span className="qualification__line"></span>
                        </div>
                    </div>

                    <div className="qualification__data">
                        <div></div>
                        <div>
                            <span className="qualification__rounder"></span>
                            <span className="qualification__line"></span>
                        </div>

                        <div data-aos="zoom-in-up" data-aos-delay="300">
                            <h3 className="qualification__title">MAN 21 Jakarta</h3>
                            <span className="qualification__subtitle">Student - Natural Sciences Major</span>
                            <div className="qualification__calender">
                                <i className="uil uil-calendar-alt"></i>
                                2017 - 2020
                            </div>
                        </div>
                    </div>

                    <div className="qualification__data">
                        <div data-aos="zoom-in-up" data-aos-delay="400">
                            <h3 className="qualification__title">Universitas Gunadarma</h3>
                            <span className="qualification__subtitle">Student - Informatics Engineering</span>
                            <div className="qualification__calender">
                                <i className="uil uil-calendar-alt"></i>
                                2020 - 2024
                            </div>
                        </div>

                        <div>
                            <span className="qualification__rounder"></span>
                            <span className="qualification__line"></span>
                        </div>
                    </div>
                </div>

                <div className={toggleState === 2 ? "qualification__content qualification__content-active" : "qualification__content"}>

                    <div className="qualification__data">
                        <div data-aos="zoom-in-up">
                            <h3 className="qualification__title">Yayasan Adipurna Inovasi Asia</h3>
                            <span className="qualification__subtitle">Front-end Web Developer</span>
                            <div className="qualification__calender">
                                <i className="uil uil-calendar-alt"></i>
                                14 Agu - 31 Des 2023
                            </div>
                        </div>

                        <div>
                            <span className="qualification__rounder"></span>
                            <span className="qualification__line"></span>
                        </div>
                    </div>

                    <div className="qualification__data">
                        <div></div>
                        <div>
                            <span className="qualification__rounder"></span>
                            <span className="qualification__line"></span>
                        </div>

                        <div data-aos="zoom-in-up" data-aos-delay="200">
                            <h3 className="qualification__title">EnterKomputer</h3>
                            <span className="qualification__subtitle">Front-end Developer</span>
                            <div className="qualification__calender">
                                <i className="uil uil-calendar-alt"></i>
                                Oct 2024 - Present
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Qualification